import { IterableElement } from 'type-fest'

import { Ticker } from '../ticker'

export const ETH_TOKEN_TICKERS = [Ticker.USDT, Ticker.USDC, Ticker.BNB, Ticker.SHIB, Ticker.PEPE]

export type EthTokenTicker = IterableElement<typeof ETH_TOKEN_TICKERS>
